import { DateTime } from 'luxon';

export const formatDate = (value: Date) =>
  Intl.DateTimeFormat(undefined, { timeZone: 'UTC' }).format(value);

export const formatDateString = (value: string) => formatDate(new Date(value));

export const currencyFormatOptionsDefaults: Omit<Intl.NumberFormatOptions, 'currency'> = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const formatInCurrency = (value: number, options?: Partial<Intl.NumberFormatOptions>) =>
  Intl.NumberFormat(undefined, { ...currencyFormatOptionsDefaults, ...options }).format(value);

export const toLocalDate = (date: DateTime) => date.toLocaleString(DateTime.DATE_SHORT);
